<template>
  <div class="popup-form popup-application-help">
    <div class="content-form-popup">
      <div class="header-text">
        <button class="back-button-wrapper pointer" type="button" aria-label="Zavrieť metodiku" @click="closePopup">
          <app-icon name="close" :size="23" />
        </button>
      </div>
      <knowledge-base-panel :initial-bank="initialBank"/>
    </div>
  </div>
</template>

<script>
import KnowledgeBasePanel from "@/components/shared/KnowledgeBase/KnowledgeBasePanel.vue";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ApplicationHelpPopUp",
  components: { KnowledgeBasePanel, AppIcon },
  props: {
    type: String,
    payload: Object,
  },
  computed: {
    initialBank () {
      return this.payload?.bank || null;
    },
  },
  methods: {
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-application-help {
  width: 92% !important;
  height: 100vh !important;
  max-height: 100vh;
  overflow: hidden !important;
}

.content-form-popup {
  height: 100%;
  overflow: hidden;
  padding: 0 !important;
}

@supports (height: 100dvh) {
  .popup-application-help {
    height: 100dvh !important;
    max-height: 100dvh;
  }
}

@media screen and (max-width: 767px) {
  .popup-application-help {
    width: 100% !important;
  }
}

.header-text {
  min-height: 0 !important;
  margin: 0 !important;
}

.back-button-wrapper {
  position: absolute;
  z-index: 5;
  top: 16px;
  right: 16px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--app-border, #d9e4f3);
  background: var(--app-surface, #fff);
  color: var(--app-primary, #2f80d5);
  box-shadow: 0 10px 25px rgba(16, 26, 82, 0.16);
  cursor: pointer;
}

:global(html[data-theme="dark"]) .back-button-wrapper {
  border-color: var(--app-border);
  background: var(--app-surface-muted);
  color: var(--app-primary);
  box-shadow: none;
}
</style>
